import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/srm/misc-purchase-order/{id}/close`。body：closeReason、updatedAt。 */
export async function closeMiscPurchaseOrder(id, payload) {
  const { data: raw } = await request.post(
    `/srm/misc-purchase-order/${id}/close`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
